import React from 'react';
import { Mail, Phone } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-24 px-6 bg-zinc-950 fade-in-section">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold mb-6">
            Let's Work <span className="text-gold">Together</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            I'm always interested in collaborating with agencies, creative teams, and brands 
            looking to build strong visual work.
          </p>
        </div>
        
        <div className="max-w-2xl mx-auto">
          <div className="text-center space-y-8">
            <h3 className="text-2xl font-bold mb-8">Contact</h3>
            
            <div className="space-y-4">
              <a 
                href="mailto:michdefancis@gmail.com"
                className="group inline-flex items-center gap-4 p-6 border border-gray-800 hover:border-gold transition-all duration-300 w-full"
              >
                <Mail className="text-magenta" size={32} />
                <div className="text-left">
                  <p className="text-sm text-gray-400 mb-1">Email</p>
                  <p className="text-xl font-medium group-hover:text-gold transition-colors">michdefancis@gmail.com</p>
                </div>
              </a>
              
              <a 
                href="tel:6318045606"
                className="group inline-flex items-center gap-4 p-6 border border-gray-800 hover:border-gold transition-all duration-300 w-full"
              >
                <Phone className="text-magenta" size={32} />
                <div className="text-left">
                  <p className="text-sm text-gray-400 mb-1">Phone</p>
                  <p className="text-xl font-medium group-hover:text-gold transition-colors">(631) 804-5606</p>
                </div>
              </a>
            </div>
            
            <div className="pt-8">
              <p className="text-gray-400 leading-relaxed">
                Whether you're looking for creative leadership on a project, or want to 
                discuss collaboration opportunities, I'd love to hear from you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;